import type {ProspectCompany} from './prospecting'
import type {Contact,Organization} from '../types'
import {canonicalCompanyContacts,verifiedCompanyClaim} from './companyWork.ts'
import {safeWorkReturn} from './workNavigation.ts'

export type CompanyCallSelection={companyId:string;phoneRouteId:string;contactId?:string|null}

// Profile selections are ephemeral and belong to one canonical company/person.
export function profileCompanyCallsPath(company:ProspectCompany,userId:string,role:string,selection?:CompanyCallSelection){
 if(selection&&(selection.companyId!==company.id||!selection.phoneRouteId))return null
 return companyCallsPath(company,userId,role,{contactId:selection?.contactId||undefined,phoneRouteId:selection?.phoneRouteId})
}

// This gate controls a navigation affordance only. Every call still needs the
// server's current owner, suppression, route and task eligibility checks.
export function canOpenCompanyCalls(company:ProspectCompany,userId:string,role:string){
 return role==='SUPER_ADMIN'||Boolean(userId&&company.ownerUserId===userId&&['REP_CLAIMED','EXISTING_OWNER_REVIEW'].includes(company.ownershipState??''))
}
export function companyCallsPath(company:ProspectCompany,userId:string,role:string,options:{contactId?:string;phoneRouteId?:string;returnTo?:string}={}){
 if(!company.id||!canOpenCompanyCalls(company,userId,role))return null
 const contacts=canonicalCompanyContacts(company)
 if(options.contactId&&!contacts.some(contact=>contact.id===options.contactId))return null
 const selected=options.contactId||contacts.find(contact=>contact.phone)?.id||contacts[0]?.id
 const params=new URLSearchParams({organizationId:company.id,returnTo:safeWorkReturn(options.returnTo??null)})
 if(selected)params.set('contactId',selected)
 if(options.phoneRouteId)params.set('phoneRouteId',options.phoneRouteId)
 return '/work/calls?'+params
}
export function claimedCompanyCallsPath(receipt:unknown,company:ProspectCompany,userId:string,role:string,returnTo?:string){
 if(!verifiedCompanyClaim(receipt,company.id,userId,company.claimVersion))return null
 return companyCallsPath({...company,ownerUserId:userId,ownershipState:'REP_CLAIMED'},userId,role,{returnTo})
}
export function companyCallContext(contacts:readonly Contact[],organizations:readonly Organization[],organizationId?:string,contactId?:string){
 const company=organizationId?organizations.find(item=>item.id===organizationId):undefined
 const scopedContacts=organizationId?(company?contacts.filter(contact=>contact.organizationId===organizationId):[]):[...contacts]
 const contact=contactId?scopedContacts.find(item=>item.id===contactId):scopedContacts[0]
 return {company,contacts:scopedContacts,contact}
}
